<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="handleSubmit">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="email"
                      required
                      class="form-control"
                      v-model="form.email"
                      placeholder="Email"
                      autocomplete="email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      required
                      class="form-control"
                      v-model="form.password"
                      placeholder="Password"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" type="submit" class="px-4">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: "Login",
  data() {
    return {
      submitted: false,
      loader: null,
      form: {
        email: null,
        password: null,
        returnUrl: null,
        InvalidLogin: false
      }
    };
  },
  
  computed: {
    ...mapState('account', ['status'])
  },
  methods: {
    ...mapActions('account', ['logout','login']),
    handleSubmit (e) {
            this.submitted = true;
            //const { username, password } = this;
            if (this.form.email && this.form.password) {
                this.login({ email: this.form.email, password: this.form.password } )
            }
            
        }
    
    // login() {
    //   try {
    //     this.loader = this.$loading.show();
    //     this.InvalidLogin = false;
    //     this.returnUrl = this.$route.query.returnUrl || "/";
    //     console.log(this.returnUrl);
    //     userService.logIn(this.form.email, this.form.password).then(result => {
    //       if (result !== null) {
    //         this.$snotify.success("Login successful", "Login");
    //         this.$router.push(this.returnUrl);
    //       } else {
    //         this.$snotify.warning("Wrong user or password", "Login");    
    //       }
    //       this.loader.hide();
    //     });
    //   } catch (err) {
    //     this.InvalidLogin = true;
    //     this.password = "";
    //     this.$snotify.warning("Wrong user or password", "Login");
    //     console.error("error", err);
    //     this.loader.hide();
    //   }
    // }
  },
  created() {
    this.logout();
  }
};
</script>
